import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GridShapeComponent } from '../common/grid-shape/grid-shape.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-found',
  imports: [
    GridShapeComponent,
    RouterModule,
  ],
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``
})
export class NotFoundComponent {

  currentYear: number = new Date().getFullYear();
}
